const initHeaderButtonsEffect = (button) => {
  button.addEventListener('mouseover', () => {
    if (document.querySelectorAll(`.${button.dataset.listType} .buttons-bottom-header__product`).length > 0) {
      button.classList.add('_with-popup--active');
    }
  });

  button.addEventListener('mouseout', () => {
    button.classList.remove('_with-popup--active');
  });
};

export default initHeaderButtonsEffect;
